import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalRanapAnak";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-awal-ranap-anak"
})
class AsesmenAwalRanapAnakStore extends VuexModule {
  loading = false;
  asesmen: any = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_RECORD(val: any) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val: boolean) {
    this.isAnyUnsavedChange = val;
  }

  @Action({ rawError: true })
  async getByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RECORD(response.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val: boolean): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }
}

export default getModule(AsesmenAwalRanapAnakStore);
